"use strict";

// import '@babel/polyfill';

import $ from 'jquery';

// import LazyLoad from 'vanilla-lazyload';

// SimpleShare
import SimpleShare from './plugins/simpleshare/index';

// AOS
import AOS from 'aos';
import 'aos/dist/aos.css';

// import { layer } from './plugins/layer/index';

// import '@splidejs/splide/css';
// import Splide from '@splidejs/splide';
// import { Grid } from '@splidejs/splide-extension-grid';

// import imagesLoaded from 'imagesloaded';
// import jQueryBridget from 'jquery-bridget';
// import Masonry from 'masonry-layout';
// jQueryBridget('masonry', Masonry, $);

// import validate from 'jquery-validation';
// import axios from 'axios';

// gsap
// import {gsap} from '-';
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// gsap.registerPlugin(ScrollTrigger);

// import * as CookieConsent from 'vanilla-cookieconsent';
// import 'vanilla-cookieconsent/dist/cookieconsent.css';

import Sticky from 'sticky-js';

// Lenis


import Lenis from 'lenis';

// import Plyr from 'plyr';
// import 'plyr/dist/plyr.css';

// import 'altcha';

// import glsl from './lygia/generative/cnoise.glsl';

import './iconfont/iconfont';


const checkAutoplaySupport = () => {
	return new Promise( ( resolve ) => {

		const video = document.createElement( 'video' );
		video.muted = true;
		video.playsInline = true;
		video.src = 'upload/media/test.mp4';

		video.play().then( () => {
			resolve( true );
		} ).catch( () => {
			resolve( false );
		} )

	} )
}

// Index
(() => {

	if (document.querySelector('.js-time')) {
		const time = $(".js-time").attr("data-time");
		const endTime = new Date(time);
		function updateTime() {
			const nowTime = new Date();
			const time = parseInt((endTime.getTime() - nowTime.getTime()) / 1000);
			if (time < 1) {
				clearInterval(intTime);
			} else {
				let d = parseInt(time / 24 / 60 / 60),
					h = parseInt((time / 60 / 60) % 24),
					m = parseInt((time / 60) % 60),
					s = parseInt((time % 60));
				m = m < 10 ? '0' + m : m;
				s = s < 10 ? '0' + s : s;
				$('#countdown-d').html(d);
				$('#countdown-h').html(h);
				$('#countdown-m').html(m);
				$('#countdown-s').html(s);
			}
		}
		const intTime = setInterval(function () {
			updateTime();
		}, 1000);
	}

	if ($('.js-sticky-nav').length) {

		// console.log('sticky-nav');

		const sticky = new Sticky('.js-sticky-nav');

	}

})();


(() => {
	// console.log(glsl);

	// checkAutoplaySupport().then( ( supportAutoplay ) => {
	// 	if ( supportAutoplay ) {
	// 		const player = new Plyr('#plyr', {
	// 			controls: []
	// 		});
	// 		// alert( '支持自动播放' );
	// 	} else {
	// 		// alert( '不支持自动播放' );
	// 		$('.js-ib-video').attr('controls', true);
	// 		const player = new Plyr('#plyr', {
		
	// 		});
	// 	}
	// } )

	// 测试用
	const domLoop = document.querySelectorAll('[data-loop]');
	if (domLoop) {
		domLoop.forEach(item => {
			const len = item.getAttribute('data-loop');
			const sourceItem = item.innerHTML;
			for (let i = 0; i < len; i++) {
				// console.log(item.innerHTML);
				// item.appendChild(item.innerHTML);
				item.innerHTML += sourceItem
			}
		});
	}
	
	console.log('test');

	const $body = document.body;
	const lenis = new Lenis();

	lenis.on('scroll', ({ animatedScroll, limit, velocity, direction, progress }) => {
		animatedScroll > 60 ? $body.classList.add('fixed-menu') : $body.classList.remove('fixed-menu')
		direction > 0 ? $body.classList.add('drop-menu') : $body.classList.remove('drop-menu')
	});

	function raf(time) {
		lenis.raf(time);
		requestAnimationFrame(raf);
	}

	requestAnimationFrame(raf);

	var scrollEvent = new Event('scroll');
	// 触发 window 上的 scroll 事件
	window.dispatchEvent(scrollEvent);


	$('.js-gotop').on('click', function(){
		lenis.scrollTo(0);
	});

	$('.js-btn-menu').on('click', function(){
		$body.classList.toggle('menu-open');
	});


	if (document.querySelector('.js-splide-ib')) {
		const splideIb = new Splide('.js-splide-ib', {

		}).mount();

		const { Elements, Autoplay } = splideIb.Components;

		splideIb.on('move mounted', function(newIndex){
			// $('.ib-tab > span').removeClass('current').eq(newIndex).addClass('current');
			// console.log(Slide);
			// console.log(newIndex, 'current');
			Elements.slides.forEach(function(item, index){
				// console.log(index);

				const videoItem = Elements.slides[index].getElementsByTagName('video')[0];
				
				if (videoItem) {
					if (index === newIndex) {
						videoItem.currentTime = 0;
						videoItem.play();
						// Elements.pause();
						Autoplay.pause();
						// console.log('pause', index, 'video');
					}
				}
				
			});
		});

		$('.js-ib-video').on('ended', function(){
			splideIb.go('>');
			Autoplay.play();
		});
	}


	if (document.querySelector('.js-splide-scroll')) {
		const splideScroll = new Splide('.js-splide-scroll', {

		}).mount();
		$('.js-scroll-prev').on('click', function() {
			splideScroll.options = {
				interval: 4000,
				speed: 800,
				easing: 'ease',
				autoplay: false
			}
			splideScroll.go('<');
		});
		$('.js-scroll-next').on('click', function() {
			splideScroll.options = {
				interval: 4000,
				speed: 800,
				easing: 'ease',
				autoplay: false
			}
			splideScroll.go('>');
		});
	}

})();

// INIT
(() => {
	// Lazyload data-src data-bg data-poster
	// var myLazyLoad = new LazyLoad({
	// 	threshold: 800
	// });

	// Social Share
	const share = new SimpleShare({
		url: '',
		title: '',
		content: '',
		pic: ''
	});
	const shareLinks = document.querySelectorAll('[data-share]');
	shareLinks.forEach(link => {
		link.addEventListener('click', () => {
			share.goShare(link.getAttribute('data-share'));
		})
	});

	AOS.init({
		duration: 800
	});


	let fontsize = [12, 14, 16, 18, 20, 24, 32, 36, 40, 48, 54, 64, 72, 80, 84, 120, 680];
	let str = '';
	for (let i = 0; i < fontsize.length; i++) {
		str += `'${fontsize[i]}': '${fontsize[i]}px',\n'hd${fontsize[i]}': '${(fontsize[i]/19.2).toFixed(4)}vw',\n`
	}
	// console.log('font-size:');
	// console.log(str);

	let maxWArr = [840, 1100, 1150, 1280, 1440];
	let maxW = '';
	for (let i = 0; i < maxWArr.length; i++) {
		maxW += `'${maxWArr[i]}': '${maxWArr[i]}px',\n'hd${maxWArr[i]}': '${(maxWArr[i]/19.2).toFixed(4)}vw',\n`
	}
	// console.log('max-width:');
	// console.log(maxW);

	let spaceArr = [1, 5, 10, 15, 16, 20, 26, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 140, 160, 180, 200, 300, 400, 1000];
	let space = '';
	for (let i = 0; i < spaceArr.length; i++) {
		space += `'${spaceArr[i]}': '${spaceArr[i]}px',\n'hd${spaceArr[i]}': '${(spaceArr[i]/19.2).toFixed(4)}vw',\n`
	}
	// console.log('spacing:');
	// console.log(space);

	let roundedArr = [4, 5, 10, 20];
	let rounded = '';
	for (let i = 0; i < roundedArr.length; i++) {
		rounded += `'${roundedArr[i]}': '${roundedArr[i]}px',\n'hd${roundedArr[i]}': '${(roundedArr[i]/19.2).toFixed(4)}vw',\n`
	}
	// console.log('rounded:');
	// console.log(rounded);

})();

// CookieConsent
(() => {
	/**
	 * All config. options available here:
	 * https://cookieconsent.orestbida.com/reference/configuration-reference.html
	*/
	document.documentElement.classList.add('cc--defaultmode');
	
	CookieConsent.run({

		categories: {
			necessary: {
				enabled: true,  // this category is enabled by default
				readOnly: true  // this category cannot be disabled
			},
			required: {
				enabled: true,  // this category is enabled by default
				readOnly: false  // this category cannot be disabled
			},
			analytics: {}
		},

		guiOptions: {
			consentModal: {
				layout: 'bar',
				position: 'bottom',
				flipButtons: false,
				equalWeightButtons: true
			},
			preferencesModal: {
				layout: 'box',
				// position: 'left right',
				flipButtons: false,
				equalWeightButtons: true
			}
		},

		language: {
			default: 'en',

			translations: {
				en: {

					consentModal: {
						title: '',
						description: 'We use our own and third-party cookies to ensure the proper functioning of the web portal and its complements, perform navigation analysis and show multimedia content. If you continue browsing, you accept the use of this technology. For more information please see our Cookies Policy. <a href="/cookie-statement" style="text-decoration:underline;">Learn more</a>',
						acceptAllBtn: 'Accept all',
						acceptNecessaryBtn: 'Reject all',
						showPreferencesBtn: 'Customize'
					},
					preferencesModal: {
						title: 'Manage cookie preferences',
						acceptAllBtn: 'Save settings',
						acceptNecessaryBtn: 'Reject all',
						savePreferencesBtn: 'Accept current selection',
						closeIconLabel: 'Close modal',
						sections: [
							// {
							// 	title: 'Somebody said ... cookies?',
							// 	description: 'I want one!'
							// },
							{
								title: 'Technically required',
								description: 'Required web technologies and cookies make our website technically accessible to and usable for you. This applies to fundamental base functionalities such as navigation on the website, correct display in your internet browser or requesting your consent. Without these web technologies and cookies our website does not work.',

								//this field will generate a toggle linked to the 'required' category
								linkedCategory: 'required'
							},
							{
								title: 'Analysis and statistics',
								description: 'We want to constantly improve the user-friendliness and performance of our websites. For this reason we use analysis technologies (including cookies) which pseudonymously measure and evaluate which functions and content of our websites are used, how and how often. On this basis we can improve our websites for users.',
								linkedCategory: 'analytics'
							}
							// ,
							// {
							// 	title: 'More information',
							// 	description: 'For any queries in relation to my policy on cookies and your choices, please <a href="#contact-page">contact us</a>'
							// }
						]
					}
				}
			}
		}
	});
});